import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import ServicesPage from "@/pages/ServicesPage";
import CopilotPage from "@/pages/CopilotPage";
import ExecutiveWorkflowPage from "@/pages/ExecutiveWorkflowPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import AdminProtected from "@/components/AdminProtected";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/copilot" element={<CopilotPage />} />
          <Route path="/executive-workflow" element={<ExecutiveWorkflowPage />} />
          <Route path="/admin" element={<Navigate to="/admin/leads" replace />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin/leads"
            element={
              <AdminProtected>
                <AdminLeadsPage />
              </AdminProtected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
